import { z } from "zod";

export const loginSchema = z.object({
  phoneNumber: z
    .string()
    .regex(/^09\d{9}$/, "شماره همراه ضروری میباشد (مثلاً 09123456789)"),
  fullName: z.string().min(2, "نام خود را وارد کنید"),
});

export type TLoginFormData = z.infer<typeof loginSchema>;
